/** @format */

import React from 'react';
import { Col, Row } from 'antd';
import { DependentInfo } from '../types';
import plus from 'img/Plus.svg';
import remove from 'img/Minus.svg';

interface DependentsListProps {
  dependents: DependentInfo[];
  onAdd: () => void;
  onRemove: (index: number) => void;
  onChange: (index: number, e: React.ChangeEvent<HTMLInputElement>) => void;
}

export const DependentsList: React.FC<DependentsListProps> = ({
  dependents,
  onAdd,
  onRemove,
  onChange,
}) => {
  return (
    <Col sm={24} md={24} lg={24} xl={24}>
      <Row gutter={[24, 24]}>
        <Col sm={24} md={24} lg={24} xl={24}>
          <div
            className='form-heading'
            style={{
              justifyContent: 'space-between',
              display: 'flex',
            }}>
            <span>Dependent Information</span>
            <button className='add-ancillary-button' type='button' onClick={onAdd}>
              <span>Add</span>
              <img src={plus} alt='plus icon' />
            </button>
          </div>
        </Col>

        {dependents.map((dependent, index) => (
          <Col key={index} sm={24} md={24} lg={24} xl={24}>
            <Row gutter={[24, 24]}>
              <Col sm={24} xl={24}>
                <div className='remove-ancillary-container'>
                  <span>Dependent {index + 1}</span>
                  <button
                    className='remove-ancillary-button'
                    type='button'
                    onClick={() => onRemove(index)}>
                    <span>Remove</span>
                    <span>
                      <img src={remove} alt='remove button' />
                    </span>
                  </button>
                </div>
              </Col>

              <Col sm={24} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>First Name *</label>
                  <input
                    type='text'
                    name='firstName'
                    value={dependent.firstName}
                    onChange={(e) => onChange(index, e)}
                    required
                  />
                </div>
              </Col>

              <Col sm={24} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>Last Name *</label>
                  <input
                    type='text'
                    name='lastName'
                    value={dependent.lastName}
                    onChange={(e) => onChange(index, e)}
                    required
                  />
                </div>
              </Col>

              <Col sm={24} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>Date of Birth *</label>
                  <input
                    type='date'
                    name='dob'
                    value={dependent.dob}
                    onChange={(e) => onChange(index, e)}
                    required
                  />
                </div>
              </Col>

              <Col sm={24} md={12} lg={12} xl={12}>
                <div className='form-input-wrapper'>
                  <label>SSN *</label>
                  <input
                    type='text'
                    name='ssn'
                    value={dependent.ssn || ''}
                    onChange={(e) => onChange(index, e)}
                    required
                  />
                </div>
              </Col>
            </Row>
          </Col>
        ))}
      </Row>
    </Col>
  );
};
